<template>
  <div class="dashboard">
    <Loader :loading="loading" loading-text="please wait..." />
    <main class="page-content">
      <div class="dashboard">
        <!-- header -->
        <header class="welcome-text mb-3">
          All Items
          <span class="welcome-name ml-2"></span>
        </header>

        <!-- main Card -->
        <div class="middle-container">
          <div
            class="box"
            @click="
              createUser = true;
              manageUser = false;
            "
          >
            <div class="card-icon">
              <i class="fa fa-use fa-2x mb-2">
                GL
                <i
                  class="fas fa-plus ml-n1"
                  style="font-size:20px; margin-top:-3px!important; position:absolute"
                ></i>
              </i>
              <div class="transaction-title">Create New Gl</div>
            </div>
          </div>
          <div
            class="box"
            @click="
              createUser = false;
              manageUser = true;
            "
          >
            <div class="card-icon">
              <i class="fa fa-2x mb-2">
                <i
                  class="fas fa-ellipsis-v"
                  style="font-size:20px; margin-top: 7px!important; margin-left:-10px; position:absolute"
                ></i>
                GLs
              </i>
              <div class="transaction-title">View Gls</div>
            </div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <div class="account-container mt-5">
          <!-- Create Gl Tab start -->
          <b-tabs pills :active-nav-item-class="current" v-if="createUser">
            <!-- Gl Tab -->
            <b-tab title-link-class title="Create GL">
              <!-- <div class="line mb-3 mt-2"></div> -->
              <div class="mt-5">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(createLedger)">
                    <div class="containe tab-con">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="row">
                            <!-- Firstname -->
                            <div class="col-md-6 mb-3">
                              <ValidationProvider
                                name="name"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <label for="v">
                                  Name
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="name"
                                    class="form-control"
                                    placeholder
                                    name="name"
                                  />
                                </div>
                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>

                            <!-- Midlename -->
                            <div class="div3i col-md-6 mb-3">
                              <ValidationProvider
                                name="category"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <div class>
                                  <label for="glCategory">
                                    Category
                                    <span class="text-danger">*</span>
                                  </label>
                                  <b-form-select
                                    v-model="category"
                                    :options="options"
                                    class
                                  ></b-form-select>
                                </div>

                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>
                          </div>
                          <!-- GL type -->
                          <div class="row">
                            <div class="form-group col-md-6 col-sm-12">
                              <ValidationProvider
                                name="type"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <label for="glType">Type</label>
                                <select
                                  name="type"
                                  class="form-control"
                                  v-model="type"
                                  id
                                >
                                  <option value>--Select--</option>
                                  <option value="parent">Parent</option>
                                  <option value="child">Child</option>
                                </select>
                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>
                            <!-- GL Parent -->
                            <div
                              class="form-group col-md-6 col-sm-12"
                              v-if="type == 'child'"
                            >
                              <ValidationProvider
                                name="type"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <label for="glType">Parent</label>
                                <select
                                  name="type"
                                  class="form-control"
                                  v-model="parent"
                                  id
                                >
                                  <option value>--Select--</option>
                                  <option
                                    :value="item._id"
                                    v-for="(item, index) in Parent"
                                    :key="index"
                                    >{{ item.name }}</option
                                  >
                                </select>
                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>

                            <div class="div3i col-md-6 mb-3">
                              <ValidationProvider
                                name="description"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <div class>
                                  <label for="description">
                                    Description
                                    <span class="text-danger">*</span>
                                  </label>
                                  <textarea
                                    name=""
                                    v-model="description"
                                    id=""
                                    cols="40"
                                    rows="3"
                                  ></textarea>
                                </div>

                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <div class="submit-btn">
                          <b-button
                            type="submit"
                            class="btn mt-3 text-center ml-3 btn-primary"
                            >Create</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-tab>
          </b-tabs>
          <!-- Create Gl tab end -->

          <!-- Manage Gl Tab start -->

          <b-tabs
            pills
            no-body
            :active-nav-item-class="current"
            v-if="manageUser"
          >
            <!-- Gl Tab -->
            <b-tab :title-link-class="active1" title="Existing GLs">
              <div class="line mb-3 mt-2"></div>
              <div class="tab-c">
                <div class="mb-0">
                  <div class="col-12">
                    <div class="top mb-2">
                      <div class="mb-3">GL</div>
                      <div>
                        <div class="input-group float-right">
                          <input
                            type="search"
                            placeholder="Search GL"
                            class="form-control"
                          />
                          <div class="input-group-append">
                            <div class="input-group-text">
                              <i class="fa fa-search"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="recent-transactions table-responsive">
                      <table>
                        <tr style="color:#333" class>
                          <th>Name</th>
                          <th>Category</th>
                          <th>Account</th>
                          <th>Type</th>
                          <th>Description</th>
                          <th>Date Created</th>
                          <th>Balance</th>
                        </tr>

                        <tr v-for="(ledger, index) in Ledgers" :key="index">
                          <td>{{ ledger.name }}</td>
                          <td>{{ ledger.category }}</td>
                          <td>{{ ledger.number }}</td>
                          <td>{{ ledger.type }}</td>
                          <td>{{ ledger.description }}</td>
                          <td>{{ ledger.createdAt }}</td>
                          <td>&#8358;{{ ledger.balance }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
          <!-- Manage User Tab end -->
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ledgerService } from "../../../services/AdminServices/Ledger.services";
import Loader from "../../../utils/vue-loader/loader.vue";

export default {
  name: "User",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loader
  },
  data() {
    return {
      createUser: true,
      manageUser: false,
      loading: false,
      name: "",
      type: "",
      parent: "",
      Ledgers: [],
      description: "",
      Admins: [],
      Customers: [],
      options: [],
      category: null,
      optionsApi: [
        {
          account: "asset",
          name: "Asset"
        },
        {
          account: "liability",
          name: "Liability"
        },
        {
          account: "income",
          name: "Income"
        },
        {
          account: "equity",
          name: "Equity"
        },
        {
          account: "expense",
          name: "Expense"
        }
      ]
    };
  },
  computed: {
    current() {
      return "current";
    },
    Parent() {
      let ledgers = this.Ledgers;
      let parent = ledgers.filter(ledger => {
        return ledger.type == "parent";
      });
      return parent;
    }
  },
  methods: {
    transfer() {
      this.$store.dispatch("transfer");
    },
    account() {
      this.$store.dispatch("account");
    },
    utility() {
      this.$store.dispatch("utility");
    },
    formatAmount(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); //this function automatically adds commas to the value where necessary
    },
    //Get Gl cxategories
    getGlCategories() {
      let optionsApi = this.optionsApi;
      let options = this.options;
      optionsApi.unshift({
        account: null,
        name: "Select Category"
      });
      optionsApi.forEach(item => {
        options.push({
          value: item.account,
          text: item.name
        });
      });
    },
    getLedgers() {
      this.loading = true;
      ledgerService
        .GetLedgers()
        .then(res => {
          this.Ledgers = res;
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createLedger() {
      this.loading = true;
      let data = {
        name: this.name,
        category: this.category,
        type: this.type,
        description: this.description,
        parent: this.parent
      };
      ledgerService
        .CreateLedger(data)
        .then(res => {
          this.$toastr.s(res.message, "Succesful!");
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeExceeded() {
      return;
    }
  },
  mounted() {
    this.$store.dispatch("fund");
    //this.getLedgers();
    //this.getGlCategories();
  }
};
</script>

<style scoped lang="scss">
.box-2 {
  padding: 24px 20px !important;
}
.box-3 {
  padding: 23px 20px !important;
}
.box-4,
.box-5 {
  padding: 25px 20px !important;
}
.box {
  cursor: pointer;
}
.link {
  text-decoration: none;
}
.middle-container {
  font-family: $SourceSansPro-Light;
  margin-right: 40px;
  //justify-content: flex-start;
}
.card-icon {
  margin: 50px 35px;
  width: 100px;
  text-align: center;
  .fa {
    color: $main-color;
  }
}

.submit-btn {
  width: 100%;
  display: flex;
  justify-content: start;
}

.btn-primary {
  background: $main-color;
  border: 1px solid $main-color;
  font-family: $SourceSansPro-Regular;
}
.current {
  background: $main-color;
}

.top {
  display: flex;
  justify-content: space-between;
}
</style>
